module.exports = __webpack_public_path__ + "media/images/pharmacies/enterprise-2050878278b829e2ec32b07e1a7685c2.png";